import { Injectable } from '@angular/core';
import { STORY_PLAYER } from '@storees/shared-constants';
import { normalizeShareCreatedAtParam } from '../utils/public-story-assets';

/**
 * Holds storyId/createdAt from Universal Links when the router has not applied
 * query params yet (common on cold start in release iOS builds).
 */
@Injectable({ providedIn: 'root' })
export class ShareDeepLinkParamsService {
  private storyId: string | null = null;
  private createdAt: string | null = null;

  /** Parse a story-player URL and cache params for the next player entry. */
  ingestUrl(url: string): boolean {
    try {
      const u = new URL(url);
      const firstSegment = u.pathname.replace(/^\//, '').split('/')[0] ?? '';
      if (firstSegment !== STORY_PLAYER) {
        return false;
      }
      const storyId = u.searchParams.get('storyId');
      const createdAtRaw = u.searchParams.get('createdAt');
      if (!storyId?.trim() || !createdAtRaw?.trim()) {
        return false;
      }
      this.storyId = storyId.trim();
      this.createdAt = normalizeShareCreatedAtParam(createdAtRaw);
      return true;
    } catch {
      return false;
    }
  }

  peek(): { storyId: string; createdAt: string } | null {
    if (!this.storyId || !this.createdAt) {
      return null;
    }
    return { storyId: this.storyId, createdAt: this.createdAt };
  }

  clear(): void {
    this.storyId = null;
    this.createdAt = null;
  }
}
